import type { RouteRecordRaw } from 'vue-router'
import { routes } from '@app/router/routes'

// Authenticated Marketplace routes, mounted under the AppLayout shell.
// - MARKETPLACE        : the seller's properties that are live or whose funding closed
// - MARKETPLACE_DETAIL : one of them — funding, window, and what investors see
//
// Not the investor or admin Marketplace (the secondary market): this one only ever
// shows the seller's own properties, during and after their funding.
export const marketplaceRoutes: RouteRecordRaw[] = [
  {
    path: routes.MARKETPLACE,
    name: 'MARKETPLACE',
    component: () => import('./MarketplaceListPage.vue'),
    meta: {
      requiresAuth: true,
      title: 'Marketplace',
      subtitle: 'Track how your live properties are funding.',
    },
  },
  {
    path: routes.MARKETPLACE_DETAIL,
    name: 'MARKETPLACE_DETAIL',
    component: () => import('./MarketplaceDetailPage.vue'),
    meta: {
      requiresAuth: true,
      title: 'Marketplace Details',
      subtitle: 'How your property is funding, and what investors see.',
    },
  },
]
